(() => {
  const initializeCounter = (element) => {
    if (element.dataset.mcLookbookCounterInitialized === 'true') return;

    const current = element.querySelector('[data-mc-lookbook-current]');
    const total = element.querySelector('[data-mc-lookbook-total]');
    if (!current || !total) return;

    let attempts = 0;

    const connect = () => {
      const swiper = element.slider;
      if (!swiper) {
        attempts += 1;
        if (attempts < 180 && element.isConnected) {
          window.requestAnimationFrame(connect);
        }
        return;
      }

      element.dataset.mcLookbookCounterInitialized = 'true';

      const pauseInactiveVideos = () => {
        swiper.slides.forEach((slide) => {
          if (slide.classList.contains('swiper-slide-active')) return;

          slide.querySelectorAll('video').forEach((video) => video.pause());
        });
      };

      const update = () => {
        current.textContent = String(swiper.realIndex + 1).padStart(2, '0');
        total.textContent = String(swiper.slides.length).padStart(2, '0');
        pauseInactiveVideos();
      };

      swiper.on('slideChange', update);
      swiper.on('slideChangeTransitionStart', pauseInactiveVideos);
      update();
    };

    customElements.whenDefined('swiper-slider').then(connect);
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-mc-lookbook-dark-slider]').forEach(initializeCounter);
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
